module.exports = __webpack_public_path__ + "assets/04babb73b2ce7b2d7f4e55ea373848ea.mp3";